import { c as _c } from "react/compiler-runtime";
import type { MedianIncomeYear } from '../constants';
import { GLOSSARY, MEDIAN_INCOME_BY_YEAR } from '../constants';
interface ConceptGridProps {
  year: MedianIncomeYear;
}

/**
 * ⑬ 중위소득 한눈에 알아두기 — 산정/활용/OECD/차상위 4개 콘셉트 카드 + 용어집.
 * - 3번째 카드(OECD)에는 분류 미니 테이블을 함께 노출.
 * - 용어집(GLOSSARY)은 연도 무관 공용.
 */
export const ConceptGrid = t0 => {
  const $ = _c(10);
  const {
    year
  } = t0;
  const {
    conceptCards
  } = MEDIAN_INCOME_BY_YEAR[year];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="font-700 text-Gray-900 typo-h5 mobile-tablet:px-16 mobile-tablet:typo-h6">중위소득, 한눈에 알아두기</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-Gray-700 typo-body4 mobile-tablet:px-16">중위소득은{" "}<strong className="font-700 text-Gray-900">경상소득의 중간값</strong>을 가구규모에 맞춰 환산한 값으로, 우리나라 복지정책의 핵심 기준선입니다.</p>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== conceptCards) {
    t3 = conceptCards.map(_temp);
    $[2] = conceptCards;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex flex-col gap-12">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-8 font-700 text-Gray-900 typo-body3">함께 알아둘 개념</div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="rounded-small bg-Gray-50 p-16 mobile-tablet:rounded-none">{t5}<dl className="flex flex-col gap-8">{GLOSSARY.map(_temp2)}</dl></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4) {
    t7 = <section className="flex flex-col gap-16">{t1}{t2}{t4}{t6}</section>;
    $[8] = t4;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
function _temp(conceptCard, idx) {
  return <article key={conceptCard.title} className="flex flex-col gap-8 rounded-small border-1 border-Gray-100 bg-Gray-25 p-16 mobile-tablet:rounded-none mobile-tablet:border-0 mobile-tablet:border-b-1 mobile-tablet:border-Gray-100 mobile-tablet:bg-transparent mobile-tablet:px-16 mobile-tablet:py-12"><div className="font-700 text-Gray-900 typo-body3">{conceptCard.title}</div><p className="text-Gray-700 typo-body4" dangerouslySetInnerHTML={{
      __html: conceptCard.body
    }} />{idx === 2 ? <table className="w-full border-collapse rounded-xsmall border-1 border-Gray-200 text-Gray-700 typo-caption1"><thead><tr className="bg-Gray-50"><th className="border-b-1 border-Gray-200 px-12 py-8 text-left font-600">구간</th><th className="border-b-1 border-Gray-200 px-12 py-8 text-left font-600">분류</th></tr></thead><tbody><tr><td className="border-t-1 border-Gray-100 px-12 py-8">{"\uC911\uC704\uC18C\uB4DD < 75%"}</td><td className="border-t-1 border-Gray-100 px-12 py-8">취약계층</td></tr><tr><td className="border-t-1 border-Gray-100 px-12 py-8">75% ~ 200%</td><td className="border-t-1 border-Gray-100 px-12 py-8">중산층</td></tr><tr><td className="border-t-1 border-Gray-100 px-12 py-8">{"> 200%"}</td><td className="border-t-1 border-Gray-100 px-12 py-8">상류층</td></tr></tbody></table> : null}{conceptCard.footnote ? <p className="text-Gray-600 typo-caption1">{conceptCard.footnote}</p> : null}</article>;
}
function _temp2(g) {
  return <div key={g.term} className="flex flex-col gap-2"><dt className="font-600 text-Gray-900 typo-body4">{g.term}</dt><dd className="text-Gray-700 typo-caption1" dangerouslySetInnerHTML={{
      __html: g.def
    }} /></div>;
}